import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import { hasEnpsModule } from 'modules/engagement/lib/hasEnpsModule'
import type { AnalyticsFilterForm } from 'modules/enps/hooks/useAnalyticsMultiFilters'
import { useForm } from 'modules/enps/hooks/useForm'
import { useQuestionGroups } from 'modules/enps/hooks/useQuestionGroups'
import CollectionsBootstrap from 'modules/enps/lib/CollectionsBootstrap'
import { EnpsFormContext } from 'modules/enps/lib/EnpsFormContext'

import Upsell from './Upsell'

const Container = observer(() => {
  const { pathname } = useLocation()

  const [analyticsFilter, setAnalyticsFilter] = React.useState<AnalyticsFilterForm | undefined>()
  const [resultsFilter, setResultsFilter] = React.useState<AnalyticsFilterForm | undefined>()
  const [refreshForm, setRefreshForm] = React.useState<boolean>(true)
  const { loading, form } = useForm(refreshForm, setRefreshForm)
  const { moduleAvailabilities } = useEngagementContext()

  const values = {
    analyticsFilter: analyticsFilter,
    form: form,
    refreshForm,
    setRefreshForm,
    loadingForm: loading,
    resultsFilter: resultsFilter,
    setAnalyticsFilter: setAnalyticsFilter,
    setResultsFilter: setResultsFilter,
  }

  if (!hasEnpsModule(moduleAvailabilities)) {
    return <Upsell />
  }

  const { access } = useCurrentSession()
  const { loading: loadingQuestionGroups, questionGroups } = useQuestionGroups({
    formId: form?.id,
    respondentId: access.id,
  })

  if (loading || loadingQuestionGroups) {
    return (
      <Box padding="s48" alignItems="center" justifyContent="center">
        <Spinner />
      </Box>
    )
  }
  if (!form) return <NotFound />

  const filteredQuestionGroups = questionGroups.filter(
    (questionGroup) => questionGroup.attributes.created_at === form.attributes.start_on
  )

  const group = filteredQuestionGroups[filteredQuestionGroups.length - 1]

  return (
    <EnpsFormContext.Provider value={values}>
      <Outlet context={{ pathname, form, group }} />
    </EnpsFormContext.Provider>
  )
})

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
